import React, { FC } from 'react';
import Stack from '@mui/material/Stack';

import { EmptyState } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

export const DataGridNoRowsOverlay: FC = () => {
  const { t } = useTranslate();
  return (
    <Stack justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
      <EmptyState title={t('global.nothingToShow')} size="small" />
    </Stack>
  );
};
